const facebookConnected = () => ({
    type: 'FACEBOOK_CONNECTED',
});

const facebookNotAuthorized = () => ({
    type: 'FACEBOOK_NOT_AUTHORIZED',
});

const facebookNotLoggedIn = () => ({
    type: 'FACEBOOK_NOT_LOGGED_IN',
});

// This is called with the results from from FB.getLoginStatus().
const facebookStatusChangeCallback = function( response ) {
    return dispatch => {
        //TODO: add error messaging based on results
        // The response object is returned with a status field that lets the
        // app know the current login status of the person.
        // Full docs on the response object can be found in the documentation
        // for FB.getLoginStatus().
        if (response.status === 'connected') {
            // Logged into your app and Facebook.
            dispatch( facebookConnected() );
        } else if (response.status === 'not_authorized') {
            // The person is logged into Facebook, but not your app.
            console.info('Facebook: Please log into this app.');
            dispatch( facebookNotAuthorized() );
        } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not.
            console.info('Please log into Facebook.');
            dispatch( facebookNotLoggedIn() );
        }
    };
};

const facebookCheckLoginState = function() {
    return ( dispatch ) => {
        return new Promise( ( resolve ) => {
            FB.getLoginStatus( ( response ) => {
                dispatch( facebookStatusChangeCallback( response ) );
                resolve( response );
            } );
        } );
    };
};

const facebookLogin = function( callback=()=>{} ) {
    return ( dispatch ) => {
        return new Promise( ( resolve ) => {
            console.info( 'Attempting to reach Facebook' );
            FB.login( () => {
                resolve( dispatch( facebookCheckLoginState( callback ) ) );
            }, { scope: 'email, public_profile' } );
        } );
    };
};

const facebookDeauthorize = function() {
    return ( dispatch ) => {
        return new Promise( ( resolve ) => {
            console.info( 'Deauthroizeing Facebook Token' );
            FB.logout( () => {
                resolve( dispatch( facebookCheckLoginState() ) );
            } );
        } );
    };
};

const facebookGetToken = function() {
    return () => {
        return Promise.resolve( FB.getAccessToken() );
    };
};

export {
    facebookCheckLoginState,
    facebookLogin,
    facebookGetToken,
    facebookDeauthorize,
};
